import styled from 'styled-components'

export const Container = styled.div`
    h2 {
        font-family: 'Poppins';
        font-size: 22px;
        font-weight: 400;
        margin-bottom: 10px;
    }
`

export const Terms = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    li {
        font-family: 'Inter';
        font-weight: 400;
        font-size: 18px;
        color: #333;
    }

    button {
        color: #4c83ee;
        &:hover {
            color: #566583;
        }
    }
`

export const OptOut = styled.div`
    margin-top: 10px;
    font-family: 'Inter', sans-serif;

    button {
        font-weight: 300;
        color: #4c83ee;
        &:hover {
            color: #566583;
        }
    }
`
